export const returnHypenIfEmpty = (data) => {
  if (data) {
    return data
  } else {
    return "-"
  }
}
